import './ElevationGraph.css';

/**
 * Compact elevation profile for the current route.
 * Plots sampled elevations as an area chart. Renders nothing without data.
 */
export function ElevationGraph({ elevation }) {
  const pts = elevation?.points;
  if (!pts || pts.length < 2) return null;

  const { minEle, maxEle, ascent } = elevation;
  const range = Math.max(1, maxEle - minEle);
  const W = 100, H = 36;
  const stepX = W / (pts.length - 1);

  const coords = pts.map((p, i) => {
    const x = i * stepX;
    const y = H - ((p.ele - minEle) / range) * H;
    return [x, y];
  });
  const line = coords.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const area = `${line} L${W},${H} L0,${H} Z`;

  return (
    <div className="elev-graph">
      <div className="elev-graph__head">
        <span className="elev-graph__title">Elevation</span>
        <span className="elev-graph__climb">↑ {ascent} m</span>
      </div>
      <svg className="elev-graph__svg" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
        <defs>
          <linearGradient id="elevFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%"   stopColor="var(--color-primary)" stopOpacity="0.35" />
            <stop offset="100%" stopColor="var(--color-primary)" stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <path d={area} fill="url(#elevFill)" />
        <path
          d={line}
          fill="none"
          stroke="var(--color-primary)"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
      <div className="elev-graph__axis">
        <span>{minEle} m</span>
        <span>{maxEle} m</span>
      </div>
    </div>
  );
}
